import { useEffect, useState } from 'react'

export default function PWAUpdateBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handleUpdate = () => setShow(true)
    window.addEventListener('sw:update-available', handleUpdate)
    return () => window.removeEventListener('sw:update-available', handleUpdate)
  }, [])

  if (!show) return null

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))',
        left: '1rem',
        right: '1rem',
        zIndex: 9999,
        padding: '0.75rem 1rem',
        borderRadius: '12px',
        background: 'var(--forest-green, #1B5E20)',
        color: '#fff',
        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
      }}
    >
      <span style={{ fontSize: '0.875rem', fontWeight: 500 }}>
        A new version is available.
      </span>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button
          type="button"
          onClick={() => setShow(false)}
          style={{
            padding: '0.5rem 0.75rem',
            borderRadius: '8px',
            border: '1px solid rgba(255,255,255,0.4)',
            background: 'transparent',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.875rem',
          }}
        >
          Dismiss
        </button>
        <button
          type="button"
          onClick={() => {
            if (typeof window.updateServiceWorker === 'function') {
              window.updateServiceWorker(true)
            }
          }}
          style={{
            padding: '0.5rem 0.75rem',
            borderRadius: '8px',
            border: 'none',
            background: '#fff',
            color: 'var(--forest-green, #1B5E20)',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 600,
          }}
        >
          Reload
        </button>
      </div>
    </div>
  )
}
